export default __webpack_public_path__ + "static/media/MaskGroup.955cebfa.png";